import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { getPageObj } from "../../../model/post";

const IssueLinks = () => {
  const {
    wp: {
      siteOptionsMetaboxSettings: {
        optionsHomeLink1Title,
        optionsHomeLink1Subtitle,
        optionsHomeLink1Page,
        optionsHomeLink2Title,
        optionsHomeLink2Subtitle,
        optionsHomeLink2Page,
      }
    },
    allWpPage: { nodes: allPages }

  } = useStaticQuery(graphql`
    query {
        wp {
            ...SiteOptions
        }
        
        allWpPage {
            ...AllWpPages
        }
    }
`)

  const issuePageObj = getPageObj(optionsHomeLink1Page, allPages);
  const filmsPageObj = getPageObj(optionsHomeLink2Page, allPages);

  return (
    <section className="issue-links">
      {issuePageObj &&
      <Link to={issuePageObj?.uri} className="issue-links__button issue-links__button--issues">
        <div className="issue-links__button-title">{optionsHomeLink1Title}</div>
        <div className="issue-links__button-subtitle">{optionsHomeLink1Subtitle}</div>
      </Link>
      }
      {filmsPageObj &&
        <Link to={filmsPageObj?.uri} className="issue-links__button issue-links__button--films">
          <div className="issue-links__button-title">{optionsHomeLink2Title}</div>
          <div className="issue-links__button-subtitle">{optionsHomeLink2Subtitle}</div>
        </Link>
      }
    </section>
  );
}

export default IssueLinks;
